import React from 'react';
import PreDeliveringContainer from './PreDeliveringContainer';

const All = (props) => (
  <PreDeliveringContainer
    title="Pre-Delivering List"
    {...props}
  />
);

export default All;
